import React, { useEffect } from 'react';
import VMSControlList from './VMSControlList';
import { FORM_MODE } from '@awp/constants';
import { AwpContainer } from '../Common/AwpContainer';

import { VMSControlContextProvider, useVMSControlContext } from './VMSControlContext';

/**
 * VMSControlAdmin Component
 * Renders the VMS Control Admin interface with context providers and container.
 *
 * @returns {JSX.Element} - The rendered VMSControlAdmin component.
 */
const VMSControlAdmin = () => {
  return (
    <AwpContainer>
      <VMSControlContextProvider>
        <VMSControlWrapper />
      </VMSControlContextProvider>
    </AwpContainer>
  );
};

/**
 * VMSControlWrapper Component
 * Determines which component to render based on the form mode from context.
 *
 * @returns {JSX.Element|null} - The rendered component based on the current form mode.
 */
const VMSControlWrapper = () => {
  const { formMode, removeInterval } = useVMSControlContext(); // Retrieve the form mode from the VMS control context

  useEffect(() => {
    return () => {
      removeInterval();
    };
  }, []);

  return formMode === FORM_MODE.LIST && <VMSControlList />; // Render the VMSControlList if the form mode is LIST
};

export default VMSControlAdmin;
